import styled from 'styled-components'

import LoadingAnimation from 'components/Common/Loading/LoadingAnimation'

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

const StyledLoadingAnimation = styled(LoadingAnimation)`
  color: ${props => props.theme.palette.brand.primary.normal};
`

function ChatHandoffLoading() {
  return (
    <StyledContainer>
      <StyledLoadingAnimation />
    </StyledContainer>
  )
}

export default ChatHandoffLoading
